import { Component, OnInit } from '@angular/core';
import { ClassroomNavbarComponent } from '../classroom-navbar/classroom-navbar.component';
import { MatIcon } from '@angular/material/icon';
import { ActivatedRoute, NavigationEnd, Router, RouterModule, RouterOutlet } from '@angular/router';
import { ClassroomDetailPage } from '@edtech-ui/core/models/Classroom/classrom-detail-page';
import { ClassroomManagementService } from '@edtech-ui/core/services/classroom-management-service/classroom-management.service';
import { ToastrService } from 'ngx-toastr';
import { MatTooltipModule } from '@angular/material/tooltip';
import { filter, finalize, tap } from 'rxjs';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
	selector: 'app-classroom-detail-page',
	standalone: true,
	imports: [ClassroomNavbarComponent, MatIcon, RouterOutlet, RouterModule, MatTooltipModule, CommonModule,MatProgressSpinnerModule],
	templateUrl: './classroom-detail-page.component.html',
	styleUrl: './classroom-detail-page.component.scss'
})
export class ClassroomDetailPageComponent implements OnInit {


	_classroom!: ClassroomDetailPage;
	classroomId!: string | null;
	isAICreationRoute = false;
	isLoading : boolean = false;


	constructor(private route: ActivatedRoute,
		private _classroomService: ClassroomManagementService,
		private _toastr: ToastrService,
		private router: Router
	) { }

	ngOnInit(): void {
		this.classroomId = this.route.snapshot.paramMap.get('id');

		if (this.classroomId) {
			this.getClassById(this.classroomId);
		}

		// Check on initial load
		this.isAICreationRoute = this.router.url.includes('/ai-creation');

		// React to future route changes
		this.router.events
			.pipe(filter(event => event instanceof NavigationEnd))
			.subscribe((event) => {
				const nav = event as NavigationEnd;
				this.isAICreationRoute = nav.urlAfterRedirects.includes('/ai-creation');
			});
	}


	getClassById(classroomId: string): void {
		this.isLoading = true ;
		this._classroomService.getClassroomById(classroomId).pipe(
			tap(response => {
				if (response.Success) {
					this._classroom = response.Data;
					this._classroomService.class_code.next(response.Data.class_code);
				}else{
					this._toastr.error(response.Message)
					this.router.navigate(['/teacher-dashboard'])
				}
			}),
			finalize(()=>{
			this.isLoading = false;
			}),
		).subscribe();
	}

	copyText(): void {
		const textToCopy = this._classroom?.class_code;
		if (textToCopy) {
			navigator.clipboard.writeText(textToCopy)
				.then(() => this._toastr.success("Class code copied!"))
				.catch(() => this._toastr.error("Failed to copy class code."));
		}
	}

}
